<!-- eslint-disable max-len -->
<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div>
    <modal id="quick-preview-article" v-if="quickArticle">
      <div class="modal-body" slot="body">
        <quick-preview :key="quickArticle.id" />
      </div>
    </modal>
    <modal id="addCartModal" v-if="selectedArticle">
      <div slot="body" class="modal-body add-cart-box text-center">
        <p class="html-content" v-html="translations.addToCartSuccessMessage"></p>
        <h4 id="productTitle">
          {{ selectedArticle.title }}
        </h4>
        <img
          :src="`${baseUrl}${selectedArticle.highlightedImageUrl}`"
          id="productImage"
          width="100"
          height="100"
          alt="adding cart image"
        />
        <div class="btn-actions">
          <router-link :to="{ name: 'ShoppingCart' }" data-dismiss="modal">
            <button class="btn-primary">
              {{ translations.goToShoppingCart }}
            </button>
          </router-link>
          <button class="btn-primary" data-dismiss="modal">
            {{ translations.continueShopping }}
          </button>
        </div>
      </div>
    </modal>
    <div class="container">
      <!--Single product-->
      <div class="product-single-container product-single-default">
        <div class="row white-box">
          <div class="col-lg-5 col-md-6">
            <div class="label-group">
              <span
                class="product-discount"
                v-if="profile.discountDataVisible && article.saleDiscountPercentage > 0"
              >
                {{ getCurrentDiscount(article) | percentage }}%
              </span>
            </div>
            <photo-gallery
              v-if="variationGallery.length"
              :gallery="variationGallery"
              :key="$route.path"
              :id="$route.path"
            />
            <photo-gallery
              v-else-if="gallery.length"
              :gallery="gallery"
              :key="article.id"
              :id="$route.path"
            />
            <div v-else>
              <img src="assets/images/no-image.jpg" />
            </div>
            <div>
              <div class="badge badge-custom" v-for="item in article.tags" :key="item.id">
                {{ item.title }}
              </div>
            </div>
            <!-- End .product-single-gallery -->
          </div>
          <!-- End .col-lg-7 -->

          <div class="col-lg-7 col-md-6">
            <div class="product-single-details">
              <router-link v-if="article.brand"
                :to="{
                    name: 'Brand',
                    params: {
                      id: article.brandId,
                      title: article.brand.replace(/\s+/g, '-')
                    }
                  }">
                <div class="single-product-cypher mb-1">
                  <span class="cypher-value">{{ article.brand }}</span>
                </div>
              </router-link>
              <div class="single-product-cypher">
                <span class="cypher-title">{{ translations.forms.labels.code }}:</span>
                <span class="cypher-value">{{ selectedVariation?.code ?? article.code }}</span>
              </div>
              <h1 class="product-title">{{ article.title }}</h1>

              <div class="ratings-container">
                <star-rating
                  :inline="true"
                  :star-size="15"
                  :read-only="true"
                  :show-rating="false"
                  :rating="article.rating"
                />
                <!-- End .product-ratings -->

                <a class="rating-link" @click.stop.prevent="openReviews()">
                  ( {{ reviews.length }} {{ translations.reviews }} )
                </a>
              </div>
              <!-- End .product-container -->
              <div v-if="(!article.disableSelling && canViewPrices) || canPassRestrictions">
                <div class="price-box">
                  <!-- <span
                    class="text-primary price-discount"
                    v-if="profile.discountDataVisible && article.salePrice"
                  >
                </span> -->

                  <span class="product-price">
                    {{ getCurrentPrice(article) | money3WithCurrency }}
                  </span>
                  <span
                    class="old-price"
                    v-if="article.oldPrice != null && article.oldPrice != 0 && article.oldPrice !== article.price"
                  >
                    <del> {{ getOldPrice(article) | money3 }} KM</del>
                  </span>
                </div>
              </div>
              <!-- End .price-box -->

              <div class="product-desc">
                <p class="html-content" v-html="article.shortDescription"></p>
                <a class="show-description" @click="openDescriptionTab"> {{ translations.showMore}} </a>
              </div>
              <!-- End .product-filters-container -->

              <div class="poduct-single-delivery available" v-if="article.stockAmount">
                <i class="icon-truck"></i>
                <span style="font-weight: 600"> {{ translations.productIsAvalible }}. <br /> </span>
              </div>

              <div class="poduct-single-delivery not-available" v-if="!article.stockAmount">
                <i class="icon-truck"></i>
                <span style="font-weight: 600">
                  {{translations.productIsAvalibleToOrder}}. <br />
                  <span v-if="article.articleAvailableInDays">
                    {{ deliveryTimeDays }}
                  </span>
                </span>
              </div>

              <div v-if="(article.disableSelling ||
                      (!article.stockAmount && !getAllowOrderingStockZero)) &&
                    !canPassRestrictions" class="text-danger my-4">
                {{ translations.itemIsAvalibleContactRepresentative }}
              </div>

              <div class="d-flex flex-column">
                <div v-for="item in article.articleAttributes?.filter((attr) => attr.linkWithArticle)"
                    :key="item.attributeId"
                    class="mb-2">
                  <p class="m-2">{{item.attributeTitle}}</p>
                  <div class="d-flex">
                    <div v-for="value in item.attributeValues" :key="value.id"
                        class="mr-2">
                      <router-link
                        :to="{ name: 'Article', params: { id: value.linkedArticle.articleId, slug: slugify(value.linkedArticle.articleTitle) } }"
                      >
                      <div v-if="item.attributeStyle == 1"
                      :style="{
                          border: `1px solid ${value.value.title}`,
                          borderRadius: '25px',
                          height: '36px',
                          width: '36px',
                          backgroundColor: `${value.value.title}`
                        }"
                        class="mx-1"></div>
                        <div v-else
                        :style="{
                          height: '36px',
                          width: '40px',
                          border: '1px solid lightgrey',
                          borderRadius: '8px'
                        }"
                        class="d-flex justify-content-center align-items-center">
                        {{ value.value.title }}
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="variations-wrapper">
                <div v-for="item in variations" :key="item.id"
                  class="variation-item"
                  :class="{
                    'selected-variation-color': isVariationSelected(item.id) && variationContainsColor(item),
                    'selected-variation': isVariationSelected(item.id) && !variationContainsColor(item),
                  }"
                  @click="selectVariation(item)">
                  <div
                    v-if="Object.keys(attributesObj).length > 0"
                    :class="{
                      'variation-combination-item-color': variationContainsColor(item),
                      'variation-combination-item': !variationContainsColor(item),
                      'active-variation': item.stockAmount > 0 && !isVariationSelected(item.id),
                      'inactive-variation': item.stockAmount === 0 && !isVariationSelected(item.id),
                      'selected-variation': isVariationSelected(item.id) && !variationContainsColor(item),
                      'selected-variation-color': isVariationSelected(item.id) && variationContainsColor(item),
                    }"
                  >
                    <div
                      v-for="attribute in item.variationCombinations"
                      :key="attribute.attributeId"
                    >
                      <div v-if="attributesObj[attribute.attributeId].attributeStyle === 1"
                        class="variation-item-secondary"
                        :style="{
                          backgroundColor: attributesObj[attribute.attributeId].attributeProperties.find(
                          (i) => attribute.attributeValueId === i.id)?.label,
                        }">
                      </div>
                      <div v-else>
                        {{
                          attributesObj[attribute.attributeId].attributeProperties.find(
                          (i) => attribute.attributeValueId === i.id)?.label
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="product-action">
                <div
                  class="product-single-qty"
                  v-if="
                    (!article.disableSelling && (article.stockAmount || getAllowOrderingStockZero)) || canPassRestrictions
                  "
                >
                  <div class="input-group bootstrap-touchspin">
                    <span
                      class="input-group-btn input-group-prepend"
                      @click="setQuantity(-article.orderQuantityRatio)"
                    >
                      <button class="btn btn-outline btn-down-icon" type="button" />
                    </span>
                    <input
                      class="horizontal-quantity form-control"
                      v-model.number="quantity"
                      @blur="handleQuantityChange"
                    />
                    <span
                      class="input-group-btn input-group-append"
                      @click="setQuantity(article.orderQuantityRatio)"
                    >
                      <button class="btn btn-outline btn-up-icon" type="button" />
                    </span>
                  </div>
                </div>
                <!-- End .product-single-qty -->
                <button
                  v-if="(!article.disableSelling && (article.stockAmount || getAllowOrderingStockZero)) || canPassRestrictions"
                  class="paction add-cart"
                  :title="translations.addToCart2"
                  @click.prevent.stop="addToCart()"
                >
                  {{ translations.addToCart2 }}
                </button>
                <!-- <button
                  v-else-if="(!article.disableSelling && (article.stockAmount || getAllowOrderingStockZero))"
                  class="paction add-cart"
                  :title="translations.addToCart2"
                  :class="{
                    disabled: (!quantity || !isStepValid(quantity, article.orderQuantityRatio)),
                  }"
                  :disabled="(!quantity || !isStepValid(quantity, article.orderQuantityRatio))"
                  @click.prevent.stop="addToCart()"
                >
                  {{ translations.addToCart2 }}
                </button> -->
                <button
                  v-if="
                    (article.disableSelling ||
                      (!article.stockAmount && !getAllowOrderingStockZero)) &&
                    !canPassRestrictions
                  "
                  class="paction add-cart"
                  @click="showOutOfStockModal(article)"
                >
                  {{ translations.availableOnRequest }}
                </button>

                <a
                  href="#"
                  class="paction btn-request-presentation"
                  :title="translations.requestPresentation"
                  @click.prevent.stop="requestPresentation()"
                  v-if="article.presentationAvailable"
                >
                  {{ translations.requestPresentation }}
                </a>

                <a
                  href="#"
                  class="paction add-wishlist"
                  :title="translations.addToWishlist"
                  :class="{ active: article.isOnWishList }"
                  @click.stop.prevent="toggleWishlistItem(article.id)"
                >
                  <span>{{ translations.addToWishlist }}</span>
                </a>
              </div>

              <!-- End .product-action -->
              <!-- End .product single-share -->
              <!--Proizvod je dostupan po narudžbi-->
              <!-- <div class="poduct-single-delivery not-available">
                <i class="icon-truck"></i>
                <span style="font-weight: 600">
                  Proizvod je dostupan po narudžbi. <br />
                  Vrijeme isporuke je 5-7 dana od narudžbe proizvoda.
                </span>
              </div> -->

              <!--Proizvod je na lageru-->
              <!-- <div class="poduct-single-delivery available">
                <i class="icon-truck"></i>
                <span style="font-weight: 600">
                  Proizvod je na lageru. <br />
                  Vrijeme isporuke je do 24 sata od narudžbe proizvoda.
                </span>
              </div> -->
            </div>
            <!-- End .product-single-details -->
          </div>
          <!-- End .col-lg-5 -->
        </div>
        <!-- End .row -->
      </div>
      <!-- End .product-single-container -->

      <div class="product-single-tabs white-box" id="nav-tabs">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link active"
              id="product-tab-desc"
              data-toggle="tab"
              href="#product-desc-content"
              role="tab"
              aria-controls="product-desc-content"
              aria-selected="true"
            >
              {{ translations.forms.labels.description }}
            </a>
          </li>

          <li class="nav-item" v-for="tab in article.tabs" :key="tab.tabId">
            <a
              class="nav-link"
              :id="`tab-${tab.tabId}`"
              data-toggle="tab"
              :href="`#tab-content${tab.tabId}`"
              role="tab"
              aria-controls="product-size-content"
              aria-selected="false"
            >
              {{ tab.tabTitle }}
            </a>
          </li>

          <li class="nav-item" v-if="article.reviewAllowed">
            <a
              class="nav-link"
              id="product-tab-reviews"
              data-toggle="tab"
              href="#product-reviews-content"
              role="tab"
              aria-controls="product-reviews-content"
              aria-selected="false"
            >
              {{ translations.tabReviews }}
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div
            class="tab-pane fade show active"
            id="product-desc-content"
            role="tabpanel"
            aria-labelledby="product-tab-desc"
          >
            <div class="entry-content list-styles">
              <div class="html-content" v-html="article.description"></div>
            </div>
          </div>
          <!-- End .tab-pane -->

          <div
            :id="`tab-content${tab.tabId}`"
            class="tab-pane fade"
            v-for="tab in article.tabs"
            role="tabpanel"
            :key="tab.tabId"
          >
            <div class="product-size-content" v-html="tab.content"></div>
          </div>

          <!-- End .tab-pane -->

          <div
            class="tab-pane fade"
            id="product-reviews-content"
            role="tabpanel"
            aria-labelledby="product-tab-reviews"
          >
            <reviews />
          </div>
          <!-- End .tab-pane -->
        </div>
        <!-- End .tab-content -->
      </div>
      <!-- End .product-single-tabs -->

      <section
        class="product-panel"
        v-if="article.linkedArticles && article.linkedArticles.length > 0"
      >
        <div class="section-title">
          <h2>{{ translations.linkedArticles }}</h2>
        </div>
        <VueSlickCarousel v-bind="slickSettings" class="linked-articles-slick">
          <div
            class="product-default inner-quickview inner-icon product-wrapper"
            v-for="linkedArticle in article.linkedArticles"
            :key="linkedArticle.id"
          >
            <figure>
              <router-link :to="{ name: 'Article', params: { id: linkedArticle.id, slug: slugify(linkedArticle.title) } }">
                <Photo :src="`${baseUrl}${linkedArticle.highlightedImageUrl}`" />
              </router-link>
              <div class="btn-icon-group">
                <button class="btn-icon btn-add-cart" @click="addToCartv2(linkedArticle)">
                  <i class="sicon-equalizer" v-if="linkedArticle.hasAttributes" />
                  <i class="icon-bag" v-else />
                </button>
              </div>
              <button
                class="btn btn-sm btn-quickview"
                data-toggle="modal"
                @click="getQuickArticle(linkedArticle.id)"
              >
                {{ translations.quickPreview }}
              </button>
            </figure>
            <div class="product-details">
              <div class="category-wrap">
                <div class="category-list">
                  <router-link
                    class="product-category"
                    :to="{ name: 'Brand', params: { id: linkedArticle.brandId, title: linkedArticle.brand.replace(/\s+/g, '-') } }"
                  >
                    {{ linkedArticle.brand }}
                  </router-link>
                </div>
                <a
                  href="#"
                  class="btn-icon-wish"
                  :class="{ active: linkedArticle.isOnWishList }"
                  @click.prevent.stop="toggleWishlistItem(linkedArticle.id)"
                >
                  <i class="icon-heart" :class="{ 'icon-heart-1': linkedArticle.isOnWishList }" />
                </a>
              </div>
              <h2 class="product-title">
                <router-link :to="{ name: 'Article', params: { id: linkedArticle.id, slug: slugify(linkedArticle.title) } }">
                  {{ linkedArticle.title }}
                </router-link>
              </h2>
              <div class="ratings-container">
                <star-rating
                  :inline="true"
                  :star-size="15"
                  :read-only="true"
                  :show-rating="false"
                  :rating="linkedArticle.rating"
                />
                <!-- End .product-ratings -->
              </div>
              <!-- End .product-container -->
              <div class="price-box" v-if="(linkedArticle.disableSelling === false && canViewPrices) || canPassRestrictions">
                <span class="product-price">
                  {{ (linkedArticle.salePrice || linkedArticle.price) | money3WithCurrency }}
                </span>
                <span
                  class="old-price"
                  v-if="linkedArticle.salePrice < linkedArticle.price && linkedArticle.salePrice"
                >
                  {{ linkedArticle.price | money3WithCurrency }} KM
                </span>
              </div>
              <div v-else class="d-flex w-100 justify-content-center p-2">
                <button
                  class="paction add-cart w-100"
                  @click="showOutOfStockModal"
                >
                {{ translations.availableOnRequest }}
                </button>
              </div>
              <!-- End .price-box -->
            </div>
            <!-- End .product-details -->
          </div>
        </VueSlickCarousel>
      </section>
    </div>

    <div class="container">
      <home-banner />
    </div>
    <recent-articles />
    <top-brands />
  </div>
</template>

<script>
/* eslint-disable no-undef */
import Vue from 'vue';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import StarRating from 'vue-star-rating';

import '../Dashboard/slick.css';
import api from '@/services/api';
import Photo from '@/components/shared/Image.vue';
import RecentArticles from '@/components/shared/article/RecentArticles.vue';
import HomeBanner from '@/components/Dashboard/HomeBanner.vue';

import config from '@/config';
import { translations } from '@/mixins';
import helpers from '@/services/helpers';
import slugify from '@/filters/slugify';

import TopBrands from '@/components/Dashboard/TopBrands.vue';
import Modal from '@/components/shared/modal/Modal.vue';
import QuickPreview from '@/components/shared/article/QuickPreview.vue';
import PhotoGallery from '@/components/shared/photo-gallery/PhotoGallery.vue';
import Reviews from './Reviews.vue';

export default {
  name: 'Article',
  mixins: [translations],
  components: {
    VueSlickCarousel,
    PhotoGallery,
    StarRating,
    QuickPreview,
    Modal,
    TopBrands,
    Photo,
    Reviews,
    RecentArticles,
    HomeBanner,
  },
  data() {
    return {
      quantity: 1,
      rating: 5,
      attributeStyles: [
        {
          id: 1,
          label: 'Boja',
        },
        {
          id: 2,
          label: 'Velicina odjeće',
        },
        {
          id: 3,
          label: 'Ostalo',
        },
      ],
      slickSettings: {
        dots: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        swipeToSlide: true,
        lazyLoad: 'ondemand',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          // {
          //   breakpoint: 576,
          //   settings: {
          //     slidesToShow: 1,
          //     slidesToScroll: 1,
          //   },
          // },
        ],
      },
      attributeCombinations: [],
      selectedArticle: null,
      variationId: null,
      selectedVariation: null,
    };
  },
  computed: {
    article() {
      return this.$store.getters.getArticle;
    },
    reviews() {
      return this.$store.getters.getReviews;
    },
    gallery() {
      if (!this.article?.gallery) return [];

      const images = this.article.gallery.images.map((item) => {
        const src = `${config.baseUrl}${item.url}`;
        const { id, isHighlighted } = item;
        return {
          src,
          isHighlighted,
          thumbnail: src,
          id,
          largeViewSrc: src,
        };
      }) || [];

      return images.sort((x, y) => {
        if (x.isHighlighted === y.isHighlighted) {
          return 0;
        }
        if (!x.isHighlighted) {
          return 1;
        }
        return -1;
      });
    },
    variationGallery() {
      if (!this.selectedVariation?.gallery) return [];

      const images = this.selectedVariation.gallery.images.map((item) => {
        const src = `${config.baseUrl}${item.url}`;
        const { id, isHighlighted } = item;
        return {
          src,
          isHighlighted,
          thumbnail: src,
          id,
          largeViewSrc: src,
        };
      }) || [];

      return images.sort((x, y) => {
        if (x.isHighlighted === y.isHighlighted) {
          return 0;
        }
        if (!x.isHighlighted) {
          return 1;
        }
        return -1;
      });
    },
    baseUrl() {
      return config.baseUrl;
    },
    attributesObj() {
      return this.$store.getters.getAttributesAsObj;
    },
    allAttributes() {
      return this.$store.getters.getAttributes;
    },
    attributes() {
      return (
        this.article?.articleAttributes?.map((item) => {
          const attribute = {
            ...this.allAttributes.find((attr) => item.attributeId === attr.id),
          };

          if (attribute) {
            // Dropdown
            if ((item.attributeStyle === 3 || item.attributeStyle === 1) && !attribute.model) {
              Vue.set(attribute, 'model', null);
            }

            attribute.attributeProperties = (attribute?.attributeProperties || [])
              .filter((attrProp) => item.attributeValues.indexOf(attrProp.id) !== -1) || [];
            if (attribute?.attributeProperties?.length) {
              if (attribute.attributeProperties.length === 1 && attribute.model === null) {
                Vue.set(attribute, 'model', attribute.attributeProperties[0].id);
                this.addAttributeCombinations({
                  attributeId: attribute.id,
                  attributeValueId: attribute.attributeProperties[0].id,
                });
              }
            }
            return attribute;
          }

          return {};
        }) || []
      );
    },
    quickArticle() {
      return this.$store.getters.getQuickArticle;
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    canViewPrices() {
      return this.profile.userData.canViewPrices;
    },
    canPassRestrictions() {
      return this.profile?.userData?.articleAlwaysVisibleOnWeb;
    },
    getAllowOrderingStockZero() {
      return this.$store.getters.getAllowOrderingStockZero;
    },
    deliveryTimeDays() {
      return this.translations.deliveryTimeDays.replace('{days}', this.article.articleAvailableInDays);
    },
    variations() {
      return this.$store.getters.getArticleVariations;
    },
    lowestVariationPrice() {
      if (this.variations.length > 0) {
        return Math.min(...this.variations.map((item) => item.vpc));
      }
      return 0;
    },
    // selectedVariation() {
    //   console.log('selectedVariation: ', this.attributeCombinations, this.variations);
    //   return this.attributeCombinations;
    // },
  },
  methods: {
    slugify,
    getCurrentPrice(item) {
      if (this.lowestVariationPrice !== 0 || this.selectedVariation) {
        if (this.selectedVariation) {
          return this.selectedVariation.vpc;
        }
        return this.lowestVariationPrice !== 0
          ? this.lowestVariationPrice : this.selectedVariation.vpc;
      }

      const salePrice = item.salePrice || 0;
      const price = item.price || 0;

      if (salePrice > 0 && salePrice < price) {
        return salePrice;
      }
      return (price === 0 ? this.lowestVariationPrice : price) || 0;
    },
    getCurrentDiscount(item) {
      const salePrice = item.salePrice || 0;
      const price = item.price || 0;
      const matchedPP = item.matchedPP || false;
      const saleDiscountPercentage = item.saleDiscountPercentage || 0;
      const baseArticlePrice = item.baseArticlePrice || 0;
      if (salePrice > 0 && salePrice < price) {
        return saleDiscountPercentage * -1;
      }
      if (matchedPP) {
        return (100 * (1 - price / baseArticlePrice) || 0) * -1;
      }
      return 0;
    },
    getOldPrice(item) {
      const salePrice = item.salePrice || 0;
      const price = item.price || 0;
      const matchedPP = item.matchedPP || false;
      const baseArticlePrice = item.baseArticlePrice || 0;
      if (salePrice > 0 && salePrice < price) {
        return (baseArticlePrice === 0 ? price : baseArticlePrice) || 0;
      }
      if (matchedPP) {
        return baseArticlePrice;
      }
      return 0;
    },
    selectVariation(variation) {
      if (variation.stockAmount === 0) {
        this.$toast.info('Odabrani artikal trenutno nije na stanju!');
        return;
      }
      if (this.variationId === variation.id) {
        this.variationId = null;
        this.selectedVariation = null;
        this.attributeCombinations = this.attributeCombinations.filter(
          (i) => i.attributeId !== variation.attributeId,
        );
      } else {
        this.variationId = variation.id;
        api.getVariationById(variation.id).then((response) => {
          this.selectedVariation = response.data.data;
          this.attributeCombinations = [];
          response.data.data.variationCombinations.forEach((item) => {
            this.attributeCombinations.push(item);
          });

          variation.variationCombinations.forEach((comb) => {
            this.attributeCombinations.push(comb);
          });
        });
      }
    },
    showOutOfStockModal(item) {
      this.$store.dispatch('showOutOfStockModal', { articleId: item.id });
    },
    isStepValid(quantity, ratio) {
      const factor = quantity < 1 || ratio < 1 ? 10 : 1;

      return (quantity * factor) % (ratio * factor) === 0;
    },
    toggleWishlistItem(articleId) {
      api.toggleWishlistItem(articleId).then((response) => {
        this.$toast.info(response.data.info);
        // this.$store.dispatch('getArticleById', this.$route.params.id);
        this.article.isOnWishList = !this.article.isOnWishList;
        this.$store.dispatch('getWishList');
      });
    },
    addToCart() {
      // if (this.attributeCombinations.length !== this.article.articleAttributes.length) {
      //   this.$toast.error('Morate izabrati sve kombinacije');
      //   return;
      // }
      // const { article } = this;
      // let percentage = 0;

      // if (this.profile.discountDataVisible && article.salePrice) {
      //   percentage = article.saleDiscountPercentage;
      // }

      // if (
      //   this.profile.discountDataVisible
      //   && !article.salePrice
      //   && article.price < article.baseArticlePrice
      // ) {
      //   percentage = ((100 - article.price) / (article.baseArticlePrice * 100)).toFixed(2);
      // }

      if (this.variations.length > 0 && !this.selectedVariation) {
        this.$toast.info('Morate odabrati barem jednu varijaciju artikla!');
        return;
      }

      api
        .addToShoppingCart({
          articleId: this.article.id,
          quantity: this.quantity,
          attributeCombinations: this.attributeCombinations,
          variationId: this.variationId,
          // discount: percentage,
        })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$store.dispatch('getShoppingCart');
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
          this.$store.dispatch('getShoppingCart');
        });
    },
    addToCartv2(item) {
      if (item.hasAttributes) {
        this.$router.push({ name: 'Article', params: { id: item.id, slug: slugify(item.title) } });
        return;
      }
      this.selectedArticle = item;
      api
        .addToShoppingCart({
          articleId: item.id,
          quantity: 1,
        })
        .then((response) => {
          $('#addCartModal').modal('show');
          this.$store.dispatch('getShoppingCart');
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    setQuantity(num) {
      let { minOrderQuantity, maxOrderQuantity, orderQuantityRatio } = this.article;

      minOrderQuantity = minOrderQuantity || 1;
      maxOrderQuantity = maxOrderQuantity || Infinity;
      orderQuantityRatio = orderQuantityRatio || 1;

      if (this.quantity <= minOrderQuantity && num === -minOrderQuantity) return;
      if (num >= orderQuantityRatio && this.quantity === maxOrderQuantity) return;
      this.quantity = parseFloat((this.quantity + num).toFixed(1), 10);

      if (this.quantity < minOrderQuantity) {
        this.quantity = minOrderQuantity;
      }

      if (this.quantity > maxOrderQuantity) {
        this.quantity = maxOrderQuantity;
      }
    },
    addAttributeCombinations(payload) {
      const { attributeCombinations } = this;
      const alreadyExists = this.attributeCombinations.some(
        (item) => item.attributeId === payload.attributeId
        && item.attributeValueId === payload.attributeValueId,
      );

      if (!alreadyExists) {
        const index = attributeCombinations.findIndex((i) => i.attributeId === payload.attributeId);

        if (index === -1) {
          this.attributeCombinations.push(payload);
        } else {
          attributeCombinations[index].attributeValueId = payload.attributeValueId;
        }
      }
    },
    isVariationSelected(variationId) {
      return this.variationId === variationId;
    },
    variationContainsColor(variation) {
      return variation.variationCombinations.length === 1 && variation.variationCombinations.some(
        (i) => this.attributesObj[i.attributeId]?.attributeStyle === 1,
      );
    },
    isAttributeCombinationActive({ attributeId, attributeValueId }) {
      return this.attributeCombinations.some(
        (i) => i.attributeId === attributeId && i.attributeValueId === attributeValueId,
      );
    },
    openReviews() {
      if (!this.article.reviewAllowed) return;
      $('a[href="#product-reviews-content"]').tab('show');
      document.getElementById('nav-tabs').scrollIntoView({ behavior: 'smooth' });
    },
    openDescriptionTab() {
      $('a[href="#product-desc-content"]').tab('show');
      document.getElementById('nav-tabs').scrollIntoView({ behavior: 'smooth' });
    },
    getQuickArticle(articleId) {
      this.$store.dispatch('getQuickViewArticle', articleId).then(() => {
        this.$store.dispatch('getArticleVariations', articleId).then(() => {
          this.$store.dispatch('getAttributes', { retrieveAll: true });
          $('#quick-preview-article').modal('show');
        });
      });
    },
    requestPresentation() {
      api.requestPresentation(this.article.id).then((response) => {
        this.$toast.info(response.data.info);
      });
    },
    handleQuantityChange() {
      let { minOrderQuantity, maxOrderQuantity, orderQuantityRatio } = this.article;

      minOrderQuantity = minOrderQuantity || 1;
      maxOrderQuantity = maxOrderQuantity || Infinity;
      orderQuantityRatio = orderQuantityRatio || 1;

      const numOfDecimals = orderQuantityRatio.toString().split('.');
      const roundTo = numOfDecimals.length > 1 ? numOfDecimals[1].length : 0;
      const num = parseFloat(this.quantity.toFixed(roundTo), 10);
      let ratio = parseFloat((num % orderQuantityRatio).toFixed(roundTo), 10);

      if (ratio < minOrderQuantity) {
        if (num > minOrderQuantity) {
          ratio = parseFloat(((num - minOrderQuantity) % orderQuantityRatio).toFixed(roundTo), 10);
        } else {
          ratio = parseFloat(((minOrderQuantity - num) % orderQuantityRatio).toFixed(roundTo), 10);
        }
      }

      // if (ratio !== 0) {
      //   console.log('ratio: ', ratio);
      //   // when ratio is integer
      //   if (Number.isInteger(orderQuantityRatio)) {
      //     this.quantity = parseFloat((this.quantity - ratio).toFixed(roundTo), 10);
      //   } else {
      //     this.quantity = parseFloat(this.quantity, 10);
      //   }
      // }

      // when ratio is integer
      if (!Number.isInteger(orderQuantityRatio)) {
        this.quantity = parseFloat(this.quantity, 10);
      } else {
        this.quantity = parseFloat((this.quantity - ratio).toFixed(roundTo), 10);
      }

      if (this.quantity < minOrderQuantity) {
        this.quantity = minOrderQuantity;
      }

      if (this.quantity > maxOrderQuantity) {
        this.quantity = maxOrderQuantity;
      }
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getArticleById', this.$route.params.id).then((article) => {
      if (article.reviewAllowed) {
        this.$store.dispatch('getReviewsForArticle', this.$route.params.id);
        this.$store.dispatch('getArticleVariations', this.$route.params.id);
      }
      this.quantity = article.minOrderQuantity || 1;
    });
    this.$store.dispatch('getAttributes', { retrieveAll: true });
    helpers.addRecentlyViewedArticle(parseInt(this.$route.params.id, 10));
  },
  destroyed() {
    this.article.gallery.images = [];
  },
  watch: {
    '$route.params.id': function getArticle(newId) {
      this.$store.dispatch('getArticleById', newId);
    },
  },
};
</script>
<style lang="scss" scoped>
.product-wrapper {
  padding: 15px;
  border-right: 1px solid #e7e7e7;
  &:last-child {
    border-left: none;
  }
}

.product-default .product-title,
.product-default a {
  display: block;
  width: 100%;
}

.btn-icon-wish {
  cursor: pointer;

  &.active {
    color: red;
  }
}

.add-wishlist.active {
  color: red;

  &:before {
    content: '\e88a';
  }
}

.config-swatch-list li.active a:before {
  font-size: 1.6rem;
}

.badge.badge-custom {
  font-size: 1.25rem;
  padding: 0.5rem 1rem;
  background-color: #f3f4f6;
  font-weight: normal;
  color: #374151;
  cursor: pointer;
  border-radius: 0.75rem;
  margin-right: 1rem;

  &:hover {
    background-color: #d1d5db;
  }
}

.btn-request-presentation {
  background: #1e84bc;
  border: 1px solid #1e84bc;
  padding-left: 10px;
  padding-right: 10px;
  color: #fff;
  font-family: inherit;
  font-size: 1.6rem;

  &:hover {
    background-color: #259ddf;
    border: 1px solid #259ddf;
  }
}

.paction.add-cart {
  cursor: pointer;

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.show-description {
  color: #259ddf !important;
  border-bottom: none !important;
  cursor: pointer;
}

.poduct-single-delivery {
  margin-bottom: 1.5rem;
}

.product-discount {
  background-color: #e27c7c;
  color: white;
  max-width: 150px;
  line-height: 60px;
  padding: 15px 40px;
  font-size: 18px;
  font-weight: 700;
}

</style>

<style>
.lingalleryContainer .lingallery figure img {
  margin: 0 auto;
}

.list-styles ul,
.list-styles ol {
  list-style: initial;
  padding-left: 20px;
}
.list-styles li {
  margin-bottom: 5px;
}

.variations-wrapper {
  display: flex;
  gap: 6px;
  margin-bottom: 15px;
}

.variation-item {
  margin-block: 4px;
}

.selected-variation {
  border: 1px solid #e7e7e7;
  border-radius: 4px;
}

.selected-variation-color {
  border: 1px solid #1e84bc;
  padding: 4px;
  border-radius: 50%;
}

.variation-combination-item-color {
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  gap: 4px;
  border: 1px solid #e7e7e7;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.variation-combination-item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  gap: 4px;
  border: 1px solid #e7e7e7;
  border-radius: 4px;
}

.active-variation {
  background-color: #fff;
  color: #4882B9  ;
}

.inactive-variation {
  background-color: #f5f5f5;
  color: #9c9b9b;
}

.selected-variation .variation-combination-item {
  background-color: #4882B9;
  color: #fff;
}

.variation-combination-item:hover {
  cursor: pointer;
  color: #4882B9;
  border: 1px solid #4882B9;
  background-color: #EBF3F8;
}

.variation-item-secondary {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.html-content a {
  color: #3598DB;
}
</style>
